
























































































































import { Component, Vue } from "vue-property-decorator";
import { Util, getPageAPIs } from "@/common/util";
import SaleBallArmActStatisticAPI from '@/common/api/operationManage/saleBallArmActStatistic';
import { DeepLoop } from "@/common/deepLoop/deepLoop";


export const pageApiList = getPageAPIs(SaleBallArmActStatisticAPI)

const maxGiveTime = 9999

const defaultForms = {
  phone: '', // 电话
  num: '', // 赠送数量
  reason: '', // 赠送原因
};

const defaultForm = {
  time: []
}

const defaultSearchVenuePageOption = {
  page: 1,
  limit: 10,
  isRearchBottom: false,
};


@Component({
  filters: {
    showMutipleShopNames(tipRow: any) {
      const {
        shop_name = '',
        assistant_shop_name = ''
      } = tipRow || {}

      const names: string[] = [shop_name, assistant_shop_name].filter((name: string) => !!name)

      return names.join('、')
    }
  }
})
export default class SaleBallArmActStatisticList extends Vue {
  private form: any = {
    // time: [],
  };
  private forms: any = {
  };

  private deepLoopUtil: any = {};


  private saleBallArmActStatisticApi = new SaleBallArmActStatisticAPI();

  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false)
    }

  }

  
  private created(): void {
    this.getSaleBallArmActStatisticList();

  }
  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false)
    }

    this.getSaleBallArmActStatisticList();
  }
  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getSaleBallArmActStatisticList();
  }

  private tableData: any[] = [];

  private formLabelWidth: string = "100px";
  
  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.getSaleBallArmActStatisticList();
  }

  private addOrUpdateSaleBallArmActStatisticTitle: string = "赠送";

  private dialogFormVisible: boolean = false;

  // private handleWakeSaleBallArmActStatisticDialog(mode: string) {
  //   this.storageLockerDialogMode = mode;

  //   this.forms = {
  //     ...this.deepLoopUtil.deepCopy(defaultForms, false),
  //   };
  //   this.dialogFormVisible = true;
  // }

  private storageLockerDialogMode: string = "";

  private handleLimitTime(val: string) {
    Util.limitIntegetInput(
        val,
        (new_val: string) => {
          const limit_val = Math.min(Number(new_val), maxGiveTime).toString();
          this.$set(this.forms, "num", limit_val);
        },
        (new_val: string) => {
          this.$set(this.forms, "num", new_val);
        }
    );
  }
  private sumbitSaleBallArmActStatisticLoading: boolean = false;

  // private handleSumbitSaleBallArmActStatistic() {
  //   const params = this.forms;
  //   this.sumbitSaleBallArmActStatisticLoading = true;
  //   this.saleBallArmActStatisticApi.give(
  //       params,
  //       () => {
  //         this.getSaleBallArmActStatisticList();
  //         this.dialogFormVisible = false;
  //         this.sumbitSaleBallArmActStatisticLoading = false;
  //       },
  //       () => {
  //         this.sumbitSaleBallArmActStatisticLoading = false;
  //       }
  //   );
  // }

  private getSaleBallArmActStatisticList(): void {
    this.saleBallArmActStatisticApi.getList(
      { ...this.getSaleBallArmActStatisticParams() },
      (res: any) => {
        this.tableData = res.data.list;
        this.tablePage.page = res.data.page;
        this.tablePage.prepage = res.data.prepage;
        this.tablePage.count = res.data.count;
      },
      () => {}
    );
  }

  private getSaleBallArmActStatisticParams(mode = "all"): any {
    const params: any = {};

    const form = this.form;

    const tablePage = this.tablePage;

    const { page, prepage } = tablePage;

    const { time } = form;

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;

      const startTime = Util.dateTimeUtilnohms(startDate);
      const endTime = Util.dateTimeUtilnohms(endDate);

      params.start_date = startTime;

      params.end_date = endTime;
    }


    if (mode === "all") {
      params.page = page;

      params.limit = prepage;

    }

    return params;
  }

}
